<template>
    <el-dialog
        title=""
        :close-on-click-modal="false"
        :show-close="false"
        :close-on-press-escape="false"
        :visible.sync="showHKTWtips"
        width="620px"
        center
    >
        <el-row style="color: red;font-weight: 600;font-size: 16px;text-align: center;margin-bottom: 12px;">[Important!!!] SCPT Project Cutover Reminder</el-row>
        <el-row style="color: #000;font-weight: 600;font-size: 16px;text-decoration: underline;">Cannot SOS</el-row>
        <el-row style="color: #000;font-size: 14px;">New Initiative: 2025/07/26 – 2025/09/21</el-row>
        <el-row style="color: #000;font-size: 14px;margin-bottom: 8px;">Hard Conversion(New GTIN code): 2025/07/26 – 2025/09/21</el-row>
        <el-row style="color: #000;font-weight: 600;font-size: 16px;text-decoration: underline;">Conditional SOS</el-row>
        <el-row style="color: #000;font-size: 14px;word-break: break-word;">Soft Conversion(Existing GTIN code. minor changes in Artwork/CN description/MFG address/weight & dimension): Master Data maintain and FPC code SISO done by 7/25.</el-row>
        <el-row style="color: #000;font-size: 14px;margin-bottom: 8px;word-break: break-word;">*It's still recommended to avoid any conversions during non-fly zone.</el-row>
        <el-row style="color: #000;font-weight: 600;font-size: 16px;text-decoration: underline;">Master Data Change</el-row>
        <el-row style="color: #000;font-size: 14px;">Master Data Change Blocked during 2025/07/26 – 2025/09/21</el-row>
        <el-row style="color: #000;font-size: 14px;word-break: break-word;">For all projects with SOS or pricing effective before 2025/11/30, completion of the master data setup by 2025/07/25 is required. (Following -8weeks readiness SOP)</el-row>
        <span slot="footer" class="dialog-footer">
        <el-button :disabled="times ? true : false" size="small" type="primary" @click="close">
            <span>Close</span>
            <span v-if="times!=0">（{{ times }}s）</span>
        </el-button>
        </span>
  </el-dialog>
</template>

<script>
    export default {
            name: 'HKTWtips',
            model: {
                prop: 'visible',
                event: 'update:visible'
            },
            props: {
                visible: {
                    type: Boolean,
                    required: false,
                    default: false
                },
            },
            data() {
                return {
                    times: 3,
                }
            },
            computed: {
                showHKTWtips() {
                    return this.visible;
                }
            },
            watch: {
                showHKTWtips(val) {
                    if (val) {
                        this.times = 3;
                        let timer = setInterval(() => {
                            if (this.times > 0) {
                                this.times--;
                            } else {
                                clearInterval(timer);
                            }
                        }, 1000);
                    }
                }
            },
            methods: {
                close() {
                    this.$emit("update:visible", false);
                    this.$emit('close');
                }
            }
        };
</script>

<style scoped>
    div /deep/ .el-dialog {
        margin-top: 0 !important;
        position: fixed !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    div /deep/ .el-dialog__body {
        padding: 10px 25px 10px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/tips/index.vue